import styled from 'styled-components';

export const PaymentDone = styled.h1`
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;

  width: 100%;
  padding: 16px;
  border-radius: 4px;
  background-color: #e8fdf3;
  color: #0e8b51;
  text-align: center;

  margin-bottom: 16px;
`;

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;

  img {
    width: 120px;
  }
`;

export const Message = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;

  &:last-of-type {
    margin-bottom: 16px;
  }
`;
